import { Link } from "react-router-dom";

const Eventyr = () => {
     return (
          <div className="eventyr">
               <section className="about" id="about">
                    <div className="content">
                         <h1>¿Cómo es Eventyr? 💎</h1>
                         <p className="guide-p">Eventyr es un servidor de supervivencia con elementos modificados en PvE & PvP. La
                              mayoría de estas características son opcionales y están presentes para mejorar la calidad de juego y
                              otorgar a los jugadores una experiencia única.</p>
                         <br />
                         <p className="guide-p">
                              El servidor posee un mundo <i>Survival</i>, además de sus respectivas dimensiones de Nether y End,
                              donde los jugadores pueden construir, proteger sus bases y terrenos en general. Además de este
                              mundo, contamos con uno específicamente para minería y recolección de recursos (<b>/warp
                                   recursos</b>) que también cuenta con sus respectivos Nether y End, en los cuales existe mayor
                              cantidad de recursos que el mundo normal, en este mundo <b>no es posible proteger construcciones y
                                   el PvP es forzado.</b> El reinicio de estos mundos es 1 vez a la semana, los días lunes durante
                              la
                              madrugada.
                         </p>
                         <br />
                         <p className="guide-p">
                              Para los jugadores amantes del PvP, poseemos una arena pvp (<b>/warp PVP</b>) donde no se pierden
                              objetos al morir, alternativamente todo jugador puede elegir activar o desactivar su modo PvP para
                              todos lo mundos (salvo el spawn) usando el comando <b>/pvp</b> en el spawn. Cabe recordar que
                              en el mundo de recursos siempre está activo el PvP, y que dentro de una protección propia no te
                              pueden atacar. Adicionalmente está prohibido matar a un jugador que tenga su PvP desactivado con
                              cualquier método.
                         </p>
                         <br />
                         <p className="guide-p">
                              Si el PvE es tu pasión, disponemos del <b>/warp dungeon</b>, en el cual periódicamente aparecen
                              criaturas únicas del servidor, y mucho más fuertes que cualquier otra criatura con las que alguna
                              vez te enfrentaste, múltiples jugadores necesitarán luchar conjuntamente para derrotarlos y
                              obtener diferentes premios.
                         </p>
                         <br />
                         <p className="guide-p">Tanto para el PvP, como para el PvE el servidor dispone de más de 150 encantamientos
                              únicos (<b>/ce</b>) ofensivos, defensivos y de utilidad, para darle un toque único al combate,
                              supervivencia, construcción y recolección de recursos en el servidor.</p>
                         <br />
                         <br />
                         <h2>Puntos de interés:</h2>
                         <ul>
                              <li>La economía del servidor se basa fundamentalmente en el intercambio entre jugadores</li>
                              <li>Los rangos del servidor son adquiridos con dinero del mismo, partiendo todos como ①Desterrado”
                                   hasta culminar en “⑫Leyenda”. A excepción del rango de pago "Titán" (<a
                                        href="https://tienda.eventyrmc.net">https://tienda.eventyrmc.net </a>).</li>
                              <li>La protección de terrenos es mediante el uso de bloques de protección (<b>/ps</b>)</li>
                              <li>Se incorpora un sistema de tumbas. Cuando mueres se genera una tumba en el lugar de tu muerte
                                   con una duración de 10 minutos.</li>
                              <li>Los jugadores pueden optar por crear sus propios warps (<b>/pwarps</b>) para crear tiendas,
                                   eventos, hacer granjas públicas, o en general para mostrar al mundo sus creaciones en el
                                   servidor.</li>
                         </ul>
                         <div className="link-container">
                              <Link to="/reglas" className="link">Siguiente - Reglas 👀</Link>
                         </div>
                    </div>
               </section >
          </div >
     );
}

export default Eventyr;